<template>
  <div>
    <el-form ref="formRef" label-width="90px">
      <el-form-item label="手机号：">
        <el-input type="input" v-model="phone" size="medium" :maxlength="11" style="width:25em;" placeholder="请输入手机号"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import {postFormData, postJson} from "@/api/api"
import { clearSmsSendNumber } from "@/api/url";
import {phoneReg } from "@/assets/shared/reg-constant";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     phone: '',
   }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!phoneReg.test(this.phone)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '手机号码格式不正确',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['phone'] = this.phone;
      postFormData(clearSmsSendNumber, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

  }
}
</script>

<style scoped>

</style>
